import React, { Component } from 'react';
import { Form, Row } from 'antd';
import { queryTaskCheckList } from '@api/task';
import './expenses.less';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import FormSearch from './FormSearch';
import TableCheckTasks from './TableCheckTasks';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentWillMount() {
    this.type = '0';
  }

  componentDidMount() {
    this.searchCondition = {};
    const { backInfo } = this.props;
    if (backInfo.path === this.props.route.path) {
      if (backInfo.start && backInfo.limit) {
        this.current = backInfo.start;
        this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        };
      }
      backInfo.name && (this.searchCondition.name = backInfo.name);
    }
    this.loadData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.route.path,
      ...this.searchCondition,
      ...this.pagination,
    };
    this.props.dispatch(setBackInfo(params));
  }

  setTableData = res => {
    this.setState({
      dataSource: {
        list: res.data,
        pagination: {
          total: res.totalSize,
          pageSize: 15,
          current: this.current,
        },
      },
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.loadData();
  };

  handleSearch = params => {
    this.searchCondition = {
      ...params,
    };
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  handleChange = val => {
    this.type = val;
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  getTaskCheckList = params => {
    queryTaskCheckList(params).then(res => {
      if (res.statusCode === 200) {
        this.setTableData(res);
      }
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.pagination,
    };
    this.getTaskCheckList(params);
  };

  render() {
    const { dataSource } = this.state;
    const parentProps = {
      dataSource,
      onChange: this.handleTableChange,
      writeLoan: this.writeLoan,
    };
    return (
      <div>
        <Row>
          <FormSearch
            onChange={this.handleChange}
            onSearch={this.handleSearch}
            {...this.searchCondition}
          />
        </Row>
        <div id="ant-small-table">
          <TableCheckTasks {...parentProps} />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create({ wrappedComponentRef: true })(Manage));



// WEBPACK FOOTER //
// ./src/components/task/taskCheck/PageWatch.js